<template>
    <div id="loader" class="ui inverted dimmer" v-bind:class="{ active: activateOn }">
        <div tabindex="0" id="loader-content" class="ui text loader"
             @keydown.shift.tab.prevent @keydown.tab.exact.prevent> <!-- Focus trap to avoid clicking things in background-->
            {{ $t('components.loader.loading') }}
        </div>
    </div>
</template>

<script>
import { focusOn } from '../js/helpers.js'

export default {
  props: {
    activateOn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    focusSelf: function () {
      focusOn('loader-content')
    }
  },
  watch: {
    activateOn: {
      handler (value) {
        if (value) {
          this.focusSelf()
        }
      }
    }
  }
}
</script>

<style scoped>
    .ui.text.loader:focus {
        outline: none !important;
    }
</style>
